import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import MenuObject from '../canvas/menu-object';
import MenuContentItems from './MenuContentItems';
import MenuContentEditItem from './MenuContentEditItem';
import MenuContentDesigns from './MenuContentDesigns';
import MenuContentImport from "./MenuContentImport";
import util from "../util";
import {markAsModified} from "../canvas/mark-as-modified";
import {createPortal} from "preact/compat";
import store from '../store';

const ITEMS = 'items';
const EDIT = 'edit';
const DESIGNS = 'designs';
const IMPORT = 'import';

export default @connect(reduce, actions)
class MenuContentModal extends Component {
  constructor() {
    super();
    
    
    this.state = {
      items: [],
      active: null,
      activeIdx: null,
      view: ITEMS,
    }
  }

  sort(sortedList, event) {
    markAsModified();
    const items = sortedList.map(i => i.item);

    this.setState({
      items,
    });

    if (store.getState().isMobileVersion) {
      MenuObject.updateContent(MenuObject.getActive(), items);
    }
  }

  addNewItem() {
    markAsModified();
    const active = new MenuObject.MenuItem();
    this.setState(old => ({
      items: [...old.items, active],
      active,
      activeIdx: old.items.length,
      view: EDIT
    }));
  }

  removeDefaultDesign() {
    this.props.setMenuObjectImportDesign(null);
    this.props.setMenuObjectImportName('');
    util.nextTick(() => {
      this.goToSavedItems();
    });
  }

  goToSavedItems() {
    if (this.props.menuObjectImportDesign) {
      this.goToImport(this.props.menuObjectImportDesign);
      return;
    }
    this.setState({view: DESIGNS});
  }

  goToImport(designId) {
    this.setState({designId, view: IMPORT});
  }

  importItems(imported) {
    markAsModified();
    this.setState({
      items: [...this.state.items, ...imported],
      view: ITEMS
    })
    if (store.getState().isMobileVersion) {
      util.nextTick(() => {
        MenuObject.updateContent(MenuObject.getActive(), this.state.items);
      }, 50);
    }
  }

  editItem(idx) {
    this.setState({
      activeIdx: idx,
      active: this.state.items[idx],
      view: EDIT
    });
  }

  goToNextItem(updated) {
    if (this.state.activeIdx + 1 >= this.state.items.length) {
      return;
    }
    this.saveItem(updated);
    this.setState({view: ITEMS});
    util.nextTick(() => {
      this.editItem(this.state.activeIdx + 1);
    }, 50);
  }

  removeItem(idx) {
    markAsModified();
    let items = [...this.state.items];
    items.splice(idx, 1);
    this.setState({items});

    if (store.getState().isMobileVersion) {
      util.nextTick(() => {
        MenuObject.updateContent(MenuObject.getActive(), this.state.items);
      }, 50);
    }
  }

  save() {
    markAsModified();
    MenuObject.updateContent(MenuObject.getActive(), this.state.items);
    this.props.onModalClose();
  }

  saveItem(updated) {
    markAsModified();
    this.setState(old => {
      let items = [...old.items];
      items.splice(old.activeIdx, 1, updated);
      return {
        items,
        view: ITEMS
      }
    });

    if (store.getState().isMobileVersion) {
      util.nextTick(() => {
        MenuObject.updateContent(MenuObject.getActive(), this.state.items);
      }, 50);
    }
  }

  saveItemAndNew(updated) {
    markAsModified();
    this.saveItem(updated);
    this.addNewItem();
  }

  selectDesign(id, name) {
    this.props.setMenuObjectImportDesign(id);
    this.props.setMenuObjectImportName(name);
    util.nextTick(() => {
      this.goToImport(id);
    });
  }

  selectLocation(id) {
    this.props.setMenuObjectImportLocation(id);
  }

  componentDidMount() {
    if (!!this.props.menuObjectItems) {
      this.setState({
        items: [...this.props.menuObjectItems]
      });
    }
  }

  goToItems() {
    this.setState({view: ITEMS});
  }

  menuContentModalClick(ev) {
    console.log("on menu content click");
    if ($(ev.target).closest('.dropdown-toggle').length === 0) {
      ev.stopPropagation();
    }
    if ($(ev.target).closest('.dropdown-menu').length === 0 && $(ev.target).closest('.dropdown-toggle').length === 0) {
      util.hideDropdown();
    }
  }

  addExampleItemsToMenu(layout, items) {
    return;
  }

  render(props, state) {
    let content = null;

    if (state.view === EDIT) {
      content = (<MenuContentEditItem
        onSave={this.save.bind(this)}
        onSaveItem={this.saveItem.bind(this)}
        onClose={(item) => {
          this.saveItem(item);
          this.save()
        }}
        onSaveItemAndNew={this.saveItemAndNew.bind(this)}
        onGoToNextItem={this.goToNextItem.bind(this)}
        active={state.active}
        hasNext={state.activeIdx !== null && state.activeIdx + 1 < state.items.length}
      />)
    } else if (state.view === DESIGNS) {
      content = (
        <MenuContentDesigns
          isAdmin={props.isAdmin}
          isDesigner={props.isDesigner}
          isLogged={props.isLogged}
          // locationId={props.menuObjectImportLocation}
          designId={props.menuObjectImportDesign}
          onGoBack={this.goToItems.bind(this)}
          onClose={this.save.bind(this)}
          onFullClose={this.save.bind(this)}
          onSelectDesign={this.selectDesign.bind(this)}
          onSelectLocation={this.selectLocation.bind(this)}/>
      )
    } else if (state.view === IMPORT) {
      content = (
        <MenuContentImport
          onGoBack={this.removeDefaultDesign.bind(this)}
          onGoToItems={this.goToItems.bind(this)}
          onClose={this.save.bind(this)}
          designId={props.menuObjectImportDesign}
          designName={props.menuObjectImportName}
          addItems={this.importItems.bind(this)}
        />
      )
    } else {
      content = (<MenuContentItems
        $element={this.props.$element}
        items={state.items}
        onSort={this.sort.bind(this)}
        onSave={this.save.bind(this)}
        onClose={this.save.bind(this)}
        onGoToSavedItems={this.goToSavedItems.bind(this)}
        onAddNewItem={this.addNewItem.bind(this)}
        onEditItemClick={this.editItem.bind(this)}
        onRemoveItemClick={this.removeItem.bind(this)}
        isMobileVersion={props.isMobileVersion}
        addExampleItemsToMenu={this.addExampleItemsToMenu.bind(this)}
      />);
    }

    return props.open ? createPortal(<div onClick={this.menuContentModalClick}>
      <div class="modal-back mo-modal-back"></div>
      <div className="modal menu-object-content mo-mob-tab">
        {content}
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}
